import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck, Award, FileCheck } from "lucide-react";

export default function HeroSection({ onOpenForm }) {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1765062166398-2ee2b6cbbbf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBidWlsZGluZyUyMG5pZ2h0fGVufDB8fHx8MTc3NjE5Mjg3N3ww&ixlib=rb-4.1.0&q=85"
          alt="Modern corporate skyline representing trademark protection and brand security"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0F1A]/95 via-[#0A0F1A]/80 to-[#0A0F1A]/60" />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 lg:py-0 w-full">
        <div className="max-w-2xl">
          {/* Overline */}
          <div className="animate-fade-in-up">
            <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-[#1E3A8A]/30 border border-[#2563EB]/30 text-[#93C5FD] text-xs font-bold uppercase tracking-[0.2em] mb-6">
              USPTO Filing Experts
            </span>
          </div>

          {/* Heading */}
          <h1
            data-testid="hero-heading"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.1] mb-6 animate-fade-in-up animation-delay-100"
          >
            Secure Your Brand's
            <br />
            <span className="text-[#2563EB]">Future</span> in the US Market
          </h1>

          {/* Subheading */}
          <p className="text-base sm:text-lg text-slate-300 leading-relaxed mb-8 max-w-xl animate-fade-in-up animation-delay-200">
            Expert USPTO trademark registration, comprehensive brand protection, and continuous monitoring. Over 1,000 trademarks successfully filed for businesses across all 50 states. Your brand deserves federal-level protection from day one.
          </p>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12 animate-fade-in-up animation-delay-300">
            <Button
              onClick={onOpenForm}
              data-testid="hero-register-btn"
              className="bg-[#DC2626] hover:bg-[#B91C1C] text-white h-12 px-8 text-sm font-semibold rounded-lg hover:scale-[1.02] active:scale-[0.98] transition-all shadow-lg shadow-red-900/30"
            >
              Register My Trademark
              <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
            <Button
              onClick={onOpenForm}
              data-testid="hero-getstarted-btn"
              variant="outline"
              className="border-white/30 text-white hover:bg-white/10 h-12 px-8 text-sm font-semibold rounded-lg transition-all"
            >
              Get Started
            </Button>
          </div>

          {/* Trust badges */}
          <div className="flex flex-wrap gap-6 animate-fade-in-up animation-delay-400">
            <div className="flex items-center gap-2">
              <ShieldCheck className="w-5 h-5 text-[#2563EB]" />
              <span className="text-slate-300 text-sm font-medium">1000+ Trademarks Filed</span>
            </div>
            <div className="flex items-center gap-2">
              <Award className="w-5 h-5 text-[#2563EB]" />
              <span className="text-slate-300 text-sm font-medium">98% Success Rate</span>
            </div>
            <div className="flex items-center gap-2">
              <FileCheck className="w-5 h-5 text-[#2563EB]" />
              <span className="text-slate-300 text-sm font-medium">USPTO Registered</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
